<template>
  <div class="members-expire-dialog-container flex">

    <el-dialog
      title=""
      class="members-expired-dialog"
      :visible.sync="visiable"
      width="380px"
      :show-close=false
      v-loading="loading"
    >
      <div class="members-expired-dialog-content row">
        <img src="@/assets/img/members-expired.svg">
        <div class="members-expired-prompt">您的会员已到期,请续费</div>
        <div class="members-expired-date" v-if="userInfo">会员到期时间: {{userInfo.expire_at}}</div>
        <el-button @click="onRenewalBtnClick" class="renewal-btn">立即续费</el-button>
        <el-button @click="onIgnoreBtnClick" class="ignore-btn">忽略</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/rest/questionQuery';

export default {
  name: 'MembersExpireDialog',
  data() {
    return {
      visiable: true,
      loading: false,
      userInfo: null
    };
  },
  methods: {
    async getUserInfo() {
      this.loading = true;
      try {
        const res = await api.getUserInfo();
        this.userInfo = res;
        this.loading = false;
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        } else {
          this.$message.error('数据请求错误');
        }
        this.loading = false;
      }
    },
    onRenewalBtnClick() {
      this.$router.push('/recharge');
    },
    onIgnoreBtnClick() {
      this.$emit('close');
      // this.membersExpiredDialogVisible = false;
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>

<style lang="scss" scoped>
.members-expire-dialog-container {
  .members-expired-dialog {
    // width: 380px;
    // height: 470px;
    .members-expired-dialog-content {
      flex-direction: column;
      align-items: center;
      height: 100%;
      width: 100%;
      position: relative;
      .members-expired-prompt {
        margin: 12px 0 12px 3px;
        color: #171717;
        font-size: 18px;
        font-weight: 600;
      }
      .members-expired-date {
        margin-left: 16px;
        color: #666666;
        font-size: 12px;
      }
      .renewal-btn {
        // position: absolute;
        // left: 50%;
        // transform: translateX(-50%);
        // bottom: 78px;
        margin-top: 16px;
        height: 40px;
        width: 132px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        font-weight: 600;
        color: #ffffff;
        background-color: #0055ff;
        &:hover {
          color: #ffffff;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
          background-blend-mode: normal, normal;
        }
        &:focus {
          color: #ffffff;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(#0055ff, #0055ff);
          background-blend-mode: normal, normal;
        }
        &:active {
          color: #ffffff;
          background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(#0055ff, #0055ff);
          background-blend-mode: normal, normal;
        }
      }
      .ignore-btn {
        // position: absolute;
        // left: 50%;
        // transform: translateX(-50%);
        // bottom: 28px;
        margin-top: 16px;
        margin-left: 0;
        padding: 0;
        height: 40px;
        width: 132px;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #666666;
        background-color: rgba(0, 11, 92, 0.03);
        &:hover {
          color: #666666;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:focus {
          color: #666666;
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
        &:active {
          color: #666666;
          background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
          background-blend-mode: normal, normal;
        }
      }
    }
    // &.el-dialog {
    //   box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    //   border-radius: 2px;
    //   border: solid 1px #f7f7fa;
    //   /deep/ {

    //     .el-dialog__header {
    //       padding: 0;
    //       .el-dialog__title {
    //         font-size: 16px;
    //       }
    //     }
    //     .el-dialog__body {
    //       height: 470px;
    //       padding: 0;
    //     }
    //     .el-dialog__footer {
    //       padding: 0;
    //     }
    //   }
    // }
  }
}
</style>
